import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/online-courses/[courseId]/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/online-courses/$courseId",
)({
  component: Page,
});
